import React from "react";
import { Link } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";

import { ButtonMenuUser } from "./cuenta.elements";
import { useTenantContext } from "../../tenant/TenantContext";
import { accountMenuItems } from "./accountMenuItems";

export const AccountMenu = () => {
    const { primaryColor } = useTenantContext();
    const { signOut } = useAuthenticator((context) => [context.user]);

    return (
        <div className="d-flex flex-column">
            <div className="d-flex flex-column">
                {accountMenuItems.map((item) => (
                    <Link
                        key={item.to}
                        to={`/cuenta/${item.to}`}
                        style={{ textDecoration: "none" }}
                    >
                        <ButtonMenuUser background={primaryColor}>
                            {item.label}
                        </ButtonMenuUser>
                    </Link>
                ))}

                <ButtonMenuUser className="text-danger" onClick={() => signOut()}>
                    Cerrar sesión
                </ButtonMenuUser>
            </div>
        </div>
    );
};
